import Button from '@components/Button';
import Column from '@components/Column';
import Row from '@components/Row';
import Text from '@components/Text';
import TextField from '@components/TextField';
import colors from '@constants/colors';
import styled from '@emotion/styled';
import useIsEmailSignIn from '@hooks/auth/useIsEmailSignIn';
import { Trans, useTranslation } from 'react-i18next';

import useSignIn from '../../hooks/useSignIn';

function SignInForm() {
    const { t } = useTranslation('signIn');
    const {
        phoneNo, onChangeValue, smsAuthNo, onChangeCode, requestSms, requestVerify,
        requestColor, verityColor, smSend,
    } = useSignIn();
    const isEmail = useIsEmailSignIn();
    const labelKey = isEmail ? 'phone.emailLabel' : 'phone.phoneLabel';
    const placeholderKey = isEmail ? 'phone.emailPlaceholder'
        : 'phone.phonePlaceholder';
    return (
        <Container fullWidth as='section' spacing={3}>
            <Column fullWidth spacing={4}>
                <Column fullWidth spacing={1}>
                    <Text color={colors.textSecondary} fontWeight='medium'>
                        {t(labelKey)}
                    </Text>
                    <Row fullWidth spacing={2}>
                        <TextField value={phoneNo}
                            onChange={onChangeValue}
                            placeholder={t(placeholderKey)}
                            inputMode={isEmail ? 'email' : 'numeric'}
                            maxLength={isEmail ? 100 : 13} />
                        <ActionButton onClick={requestSms}
                            variant='outlined'
                            size='small'
                            type='button' >
                            {smSend ? t('phone.resendCode') : t('phone.requestCode')}
                        </ActionButton>
                    </Row>
                </Column>
                <Column fullWidth spacing={1}>
                    <Text color={colors.textSecondary} fontWeight='medium'>
                        {t('phone.codeLabel')}
                    </Text>
                    <Row fullWidth spacing={2}>
                        <TextField value={smsAuthNo}
                            onChange={onChangeCode}
                            placeholder={t('phone.codePlaceholder')}
                            inputMode='numeric'
                            maxLength={6}/>
                        <ActionButton onClick={requestVerify}
                            size='small'
                            variant='outlined'
                            type='button' >
                            {t('phone.verifyCode')}
                        </ActionButton>
                    </Row>
                </Column>
            </Column>
            <Row spacing={1.5}>
                <Text color={colors.textThird}
                    size='body-long' >
                    <Trans ns='signIn'
                        i18nKey='phone.privacyConsignee'
                        components={{ b: <b/> }} />
                </Text>
                <Separator/>
                <Text color={colors.textThird}
                    size='body-long' >
                    <Trans ns='signIn'
                        i18nKey='phone.privacyPurpose'
                        components={{ b: <b/> }} />
                </Text>
            </Row>
        </Container>
    );
}

const Container = styled(Column)`
    flex: 1;
    padding: var(--spacing-4);
`;

const Separator = styled.div`
    background-color: var(--color-gray5);
    height: 8px;
    width: 1px;
`;

const ActionButton = styled(Button)`
    border-radius: var(--radius-sm)
`;

export default SignInForm;
